import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'

import { Select } from 'components/fields'

export default class ConfigCodeList extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    codeListsById: PropTypes.array.isRequired,
    fetchCodeListById: PropTypes.func.isRequired
  }

  componentWillMount = () => {
    const { data } = this.props

    this.props.fetchCodeListById(get(data, 'codeListValue.codeList.id') || 35)
  }

  componentWillReceiveProps = nextProps => {
    const { data } = this.props

    if (
      get(data, 'codeListValue.codeList.id') !==
      get(nextProps.data, 'codeListValue.codeList.id')
    ) {
      this.props.fetchCodeListById(
        get(nextProps.data, 'codeListValue.codeList.id')
      )
    }
  }

  render() {
    const { data, codeListsById } = this.props

    return (
      <Select
        label={get(data, 'configurationKey.translatedDescription')}
        name="codeListValueTranslated"
        options={codeListsById}
      />
    )
  }
}
